import * as adobe from './adobe';
import parseUrl from '../helpers/url-parse';

function getRedirectUrlFromMetaTag() {
    const redirecturl = document.querySelector('#redirecturl');
    if (redirecturl) {
        const value = redirecturl.getAttribute('content');
        if (value) {
            return value;
        }
    }
    return '';
}

export default {
    callable(ele: Element) {
        ele.setAttribute('data-click-counted', 'true');
        const parsed = parseUrl(window.location.href);
        adobe.trackEvent(parsed.params);
        setTimeout(() => {
            window.location.href = getRedirectUrlFromMetaTag();
        }, 500);
    },
};
